import { useMemo } from "react";

import type { Page, Room } from "../schema";
import { useCurrentRoomUser } from "./useCurrentRoomUser";

// Pages can be marked `hidden: true` to suppress them from nav + deep links
// (e.g. the Onboarding tab is hidden until the Pipedrive deal hits the lifecycle
// pivot from prospect to onboarding). Bison staff bypass the hide so SMs can
// preview the page before it goes live to the supplier.
export function isStaff(email: string | null | undefined): boolean {
    return !!email && email.toLowerCase().endsWith("@bisoncommerce.com");
}

export interface UseVisiblePagesResult {
    /** Pages the current user should see in nav + can deep-link to. */
    pages: Page[];
    /** True for Bison staff - they see every page including hidden ones. */
    isStaff: boolean;
    loading: boolean;
}

export function useVisiblePages(room: Room): UseVisiblePagesResult {
    const { user, loading } = useCurrentRoomUser();
    const staff = isStaff(user?.email);
    const pages = useMemo(
        () => (staff ? room.pages : room.pages.filter((p) => !p.hidden)),
        [room.pages, staff],
    );
    return { pages, isStaff: staff, loading };
}
